export default __webpack_public_path__ + "e92b7f569ee6354776cd60c2b0d312f1.svg";